import React, { useRef } from 'react'
import ResumeNavbar from './ResumeNavbar'
import '../main.css'
import Preview from './preview'
import { connect } from "react-redux";

function Layout({ view,resumeReducer }) {
    const pdfExportComponent = useRef(null);
    return (
        <>
            <div className='mb-5'>
                <div className='flex space-x-4'>
                    <div className='content-area'>
                        <ResumeNavbar downloadRef={pdfExportComponent} />
                        {view}
                    </div>
                    <div className='canvas-area'>
                        <Preview ref={pdfExportComponent} resumeData={resumeReducer}/>
                    </div>
                </div>
            </div>
        </>
    )
}
const mapStateToProps = (state) => {
    return state;
};
export default connect(mapStateToProps, null)(Layout)